/**
 * Loads payload passed from the Rails app as JSON inside a <script type="application/json">...</script>
 * @param {Element} root - Root element containing the script element with JSON payload
 * @returns {any}
 */
export function loadRailsPayload(root) {
  return JSON.parse(
    root.querySelector('script[type="application/json"]').textContent
  )
}
